export default {
  delete_success: 'Delete success.',
  delete_failed: 'Delete Failed',
  you_will_need_to: 'You will need to:',
  add_new_admin_or_del_all_titles: 'add a new admin or delete all titles.',
  delete_account: 'Delete Account',
  only_user_or_owner_desc:
    'If you are the only user or owner in a studio, you will need to:',
  add_admin_or_del_all: 'a) add a new admin or b) delete all titles.',
  process_irreversible_desc:
    'This process is irreversible and may take several minutes to complete. You will receive an email when your account is fully deleted.',
  sure_delete_account: 'Are you sure you want to delete your InGame account?',
  email_address: 'Email Address',
  change_password: 'Change Password',
  registration_time: 'Registration(UTC)',
  registration_time_local: 'Registration',
  click_del_account_desc:
    'Click Delete my account to start the process of permanently deleting your InGame account.',
  click_del_support_account_desc:
    'Click Delete my account to start the process of permanently deleting your InGame Support account.',
  edit_name_success: 'Edit display name success!',
  reset_password_success: 'Reset password success.',
  reset_password_fail: 'Reset password failed.',
  old_password_try_again: 'Old password error. Try again.',
  Identity_verification_expired:
    'Identity verification is expires,please try again.',
  current_password: 'Current Password',
  input_your_password: 'Please input your password!',
  enter_your_password: 'Please enter your password',
  new_password: 'New Password',
  enter_new_password: 'Please enter your password',
  confirm_password: 'Confirm Password',
  passwords_not_match: 'Those passwords did not match. Try again.',
  please_repeat_password: 'Please repeat the password',
  time_zone_setting: 'Time Zone Settings',
  time_zone_setting_desc:
    'This setting applies to your personal display time zone. Changing it will not affect game configuration or rule execution, and only impacts how time is shown in the console.',
  please_enter_city: 'Search by city',
};
